import { states } from 'states-us';

export const STATE_NAMES: Record<string, string> = states.reduce(
  (acc, state) => {
    acc[state.abbreviation] = state.name;
    return acc;
  },
  {} as Record<string, string>,
);

export const getStateName = (abbr: string): string => STATE_NAMES[abbr] ?? abbr;
